import React, {useRef, useEffect} from 'react'
import {graphql} from "gatsby";
import parse from 'html-react-parser';
import { Asset } from '../../../../plugins/gatsby-plugin-atollon';
import { gsap } from 'gsap';

const ImageHeader = ({ image, video, title, h1, centerTitle }) => {

  const headingRef = useRef();

  React.useEffect(() => {
    const words = headingRef?.current?.querySelectorAll(".word")

    const tl = gsap.timeline({ defaults: { duration: 1, ease: "power4.out" } })

    tl.set(words, { overflow: "hidden" })
      .to({}, 0.3, {})
      .set(words, { y: 100, skewX: -10, rotateX: -1, opacity: 0, stagger: 0.1 });

    tl.set(headingRef.current, { opacity: 1 })
    tl.to(words, { y: 0, skewX: 0, rotateX: 0, opacity: 1, stagger: 0.1 }, "-=0.3")

    return () => {
      tl.kill()
    }
  }, [])

  return (
    <section className={`image-header${centerTitle ? ' image-header--center' : ''}`}>
      { video && <video className='image-header__video' autoPlay loop muted playsInline src={video} /> }
      { image && !video && <Asset className='image-header__image' asset={image} /> }
      <div className='image-header__inner'>
        {title && h1 &&
          <h1 ref={headingRef} style={{ opacity: 0 }}>
            {title.split(' ').map((el, index) => (
              <span key={index}><span className='word'>{el}</span></span>
            ))}
          </h1>
        }
        {title && !h1 &&
          <h2 ref={headingRef}>
            {title.split(' ').map((el, index) => (
              <span key={index}><span className='word'>{el}</span></span>
            ))}
          </h2>
        }
      </div>
    </section>
  )
}

export default ImageHeader

export const query = graphql`
  fragment ImageHeaderProps on DatoCmsImageHeader {
    ... on DatoCmsImageHeader {
      title
      video
      centerTitle
      h1
      image {
        ...InternalAssetProps
      }
    }
  }
`